import React from "react";
const Header = () => <h1>Vicente Plata</h1>;
Header.displayName = "Header";

export default React.memo(Header);
